import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Cross.es.js";
const r = o.forwardRef((s, e) => /* @__PURE__ */ o.createElement(t, { ref: e, ...s, weights: a }));
r.displayName = "CrossIcon";
const n = r;
export {
  n as Cross,
  r as CrossIcon
};
